import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { KeyTextI } from '~src/interfaces/translate.interface';

import { HeaderContainer, MainCol, RightCol } from './lightTwoColsHeader.sc';

interface Props {
  title: KeyTextI;
  descr: KeyTextI;
  withBorder?: boolean;
  smallHeader?: boolean;
}

const LightTwoColsHeader: FC<Props> = memo(props => {
  const [t] = useTranslation();
  return (
    <HeaderContainer $withBorder={props.withBorder} className={props.smallHeader ? 'small-header' : ''}>
      <MainCol className={props.smallHeader ? 'small-header' : ''}>
        <h1 data-translation={props.title.key}>{props.title.txt || t(props.title.key)}</h1>
        <div className="description" data-translation={props.descr.key}>
          {props.descr.txt || t(props.descr.key)}
        </div>
      </MainCol>
      {props.children && <RightCol>{props.children}</RightCol>}
    </HeaderContainer>
  );
});
export default LightTwoColsHeader;
